<template>
  <div class="score-ranking">
    <el-tabs v-model="type" class="bg-white" type="card" @tab-click="getData">
      <el-tab-pane name="0" label="今天"></el-tab-pane>
      <el-tab-pane name="1" label="本周"></el-tab-pane>
      <el-tab-pane name="2" label="本月"></el-tab-pane>
      <el-tab-pane name="4" label="全部"></el-tab-pane>
    </el-tabs>
    <div class="content bg-white">
      <el-table :data="datas" stripe v-loading="loading" :row-class-name="currentUser" :span-method="spanMethod">
        <el-table-column label="排名" prop="rank" align="center">
          <template slot-scope="scope">
            <svg v-if="scope.row.rank <= 3" class="iconsvg" aria-hidden="true">
              <use :xlink:href="'#icon-jb' + scope.row.rank"></use>
            </svg>
            <span v-else>{{scope.row.rank}}</span>
          </template>
        </el-table-column>
        <el-table-column label="昵称" prop="name" align="center"></el-table-column>
        <el-table-column label="积分" prop="score" align="center"></el-table-column>
        <el-table-column label="学习课程" prop="stage" align="center"></el-table-column>
        <el-table-column label="学习时长" prop="elap" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.elap | timeText}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'score-ranking',
  data () {
    return {
      type: this.cycle,
      loading: false,
      datas: []
    }
  },
  props: {
    category: { // 0 全校，1 班级
      type: String,
      required: true
    },
    cycle: {
      type: String,
      default: '0'
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      // 获取数据
      this.$http.get(`user/rank?top=10&sibling=1&type=${this.type}&scope=${this.category}`)
        .then(response => {
          this.machiningData(response)
        })
        .catch(() => {
          this.datas = []
          this.$message.error('获取数据失败，请重试')
        })
        .then(() => {
          this.loading = false
        })
    },
    machiningData (data) {
      this.$nextTick(() => {
        if (!(data.top && data.top.length > 0 && data.my && data.my.length > 0)) {
          this.datas = []
          return false
        }
        let list = data.top
        let last = false
        if (data.my && data.my.length > 0) {
          let me = null
          let meIndex = -1
          data.my.forEach((element, i) => {
            if (element.me) {
              me = element
              meIndex = i
              return false
            }
          })
          if (meIndex >= 0) {
            if (me.rank > 9) {
              if (me.rank > 10) {
                if (me.rank > 11) {
                  if (me.rank > 12 || meIndex === 0) {
                    list.push({
                      rank: '',
                      name: '···',
                      score: ''
                    })
                  }
                  // 加上前一名
                  if (meIndex > 0) {
                    list.push(data.my[meIndex - 1])
                  }
                }
                list.push(me)
              }
              // 加上后一名
              if (meIndex + 1 < data.my.length) {
                list.push(data.my[meIndex + 1])
              } else {
                last = true
              }
            }
          }
        }
        if (!last) {
          list.push({
            rank: '',
            name: '···',
            score: ''
          })
        }
        this.datas = list
      })
    },
    currentUser (obj) {
      return obj.row.me ? 'red' : ''
    },
    spanMethod ({ row, column, rowIndex, columnIndex }) {
      if (row.name === '···' && row.rank === '') {
        if (column.property === 'name') {
          return [1, 5]
        } else {
          return [0, 0]
        }
      }
    }
  }
}
</script>

<style lang="scss">
.score-ranking {
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav {
    width: calc(100% - 2px);
  }
  .el-tabs__item {
    width: 25%;
    text-align: center;
  }
  .el-table th {
    background: #f5f7fa;
  }
  .el-table__body tr:last-child td {
    border-bottom-width: 0;
  }
  .content {
    border: 1px solid #e4e7ed;
    border-radius: 0 0 4px 4px;
    border-top-width: 0;
    padding: 15px;
  }
  .red td {
    font-size: 16px;
  }
  .iconsvg {
    font-size: 24px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/user/scoreRanking.vue